
import React from 'react'
import { Button } from '@mui/material'
import { withStyles, createStyles } from '@mui/styles'
import { withComponentContext } from 'widgets-shared/core'
import { withTranslations } from 'widgets-shared/core'
import { compose } from 'widgets-shared/core'
import { getBookmakerLogoUrlByType } from 'smartstream-widgets/utils/logos'
import { bookmakersNames } from 'smartstream-widgets/constants/bookmakers'

import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { PropTranslations } from 'smartstream-widgets/types/widget'

type Props = {
  classes: {
    [K in string]: string
  },
  config: {
    BASE_ASSET_PATH: string,
    CTA?: {
      logoType: string,
      link: string,
      target: string,
      message: string,
      useLogo: boolean,
      variant: "contained" | "text"
    },
    defaultLink: string
  },
  sourceId: string,
  translations: PropTranslations
}

const styles = () => createStyles({
  contained: {
    minWidth: 100
  },
  icon: {
    paddingLeft: 8
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'none',
    letterSpacing: 0
  },
  text: {
    '& $label': {
      textDecoration: 'underline'
    }
  },
  root: {
    boxShadow: 'none',
    minHeight: 30,
    padding: '4px 8px'
  },
  muiButtonLabel: {
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
    width: '100%'
  }
})

function GSCTA(props: Props) {
  const {
    classes,
    config: {
      BASE_ASSET_PATH,
      CTA: {
        useLogo = false,
        logoType = '',
        link,
        message,
        target = '_blank',
        variant = 'contained'
      } = {},
      defaultLink
    } = {},
    sourceId = '',
    translations
  } = props

  const href = link || defaultLink
  const label = message || translations.defaultLabel

  return (
    <>
      {
        href &&
        <Button
          data-testid="cta-button"
          data-ht-category='call-to-action'
          data-ht-label={`${label}${useLogo && sourceId ? ` [${bookmakersNames[sourceId]}]` : ''}`}
          classes={{ contained: classes.contained, root: classes.root, text: classes.text }}
          color='primary'
          href={href}
          target={target}
          disableRipple={true}
          variant={variant}>
          <span className={` ${classes.label} `}>
            {label}
            {
              useLogo &&
              <img
                src={getBookmakerLogoUrlByType(BASE_ASSET_PATH, sourceId, logoType)}
                alt={bookmakersNames[sourceId]}
                className={classes.icon}
              />
            }
          </span>
        </Button>
      }
    </>
  )
}

export default compose(
  withComponentContext,
  withStyles(styles, { name: 'GSCTA' }),
  withTranslations((t: TranslationFunction) => {
    return {
      ctaIcon: t('gscta.icon.translation', {
        defaultValue: 'CTA icon',
        context: 'Image alternative text in GSCTA control'
      }),
      defaultLabel: t('gscta.label.translation', {
        defaultValue: 'View odds',
        context: 'Text to display as call to action label in GSCTA control'
      })
    }
  })
)(GSCTA)
